import { render, staticRenderFns } from "./MainBannerDetails.vue?vue&type=template&id=50de8b7f&scoped=true"
import script from "./MainBannerDetails.vue?vue&type=script&lang=js"
export * from "./MainBannerDetails.vue?vue&type=script&lang=js"
import style0 from "./MainBannerDetails.vue?vue&type=style&index=0&id=50de8b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de8b7f",
  null
  
)

export default component.exports